import { getDefaultFormValues } from "shared/Scan/helpers";
import { ScanFormFields } from "shared/Scan/types";

import { ScanSettingsItem } from "../gql";

export type ScanSettingsCloudProviderFormFields = Pick<
  ScanFormFields,
  "providerVersion" | "integrationId" | "regions"
>;

export const getFormDefaultValues = (
  scanSettings: ScanSettingsItem
): ScanSettingsCloudProviderFormFields => {
  const { providerVersion, integrationId, regions } = getDefaultFormValues(scanSettings);
  return { providerVersion, integrationId, regions };
};
